import React from 'react';
import SalesNav from './SalesNav';
import PricingSection from './PricingSection';
import useLangganan from '../hooks/useLangganan';
import FaqSection from './FaqSection';

/* ═══════════════════════════════════════════════════════════════
   PricingBaruView — SALESPAGE PENUH (public, tiada app shell/sidebar)
   ───────────────────────────────────────────────────────────────
   Design tokens diselaraskan dengan /sesaat-1 (SalesPageView):
     bg #f4f3ef · ink #14130f · muted #6b6a64 · border #e6e3db
     surface #fff · accent #5b53e8 · lime #bef264
     font Inter (badan) + Instrument Serif (aksen italik)
   Light-only (macam salespage — tiada dark mode).
   Route di-handle via early-return dalam App.jsx (sebelum shell).

   Desktop = table perbandingan (contained ~1160px, highlight kolum
   popular). Mobile = kad bertindih + checklist (md:hidden ↔ md:block).
   Kad popular = hitam + butang lime (pilihan user). Harga & modul = PLACEHOLDER.
   ═══════════════════════════════════════════════════════════════ */

const FOOTER_COLS = [
    { title: 'Produk',   links: ['Ciri-ciri', 'Harga', 'Modul', 'Muat turun extension'] },
    { title: 'Syarikat', links: ['Tentang kami', 'Hubungi', 'Kerjaya'] },
    { title: 'Sumber',   links: ['Panduan', 'Tutorial', 'Sokongan', 'Blog'] },
    { title: 'Afiliat',  links: ['Jadi affiliate', 'Komisen', 'Sumber afiliat'] },
    { title: 'Sosial',   links: ['TikTok', 'Facebook', 'Instagram', 'YouTube'] },
    { title: 'Legal',    links: ['Terma', 'Privasi', 'Bayaran balik'] },
];

export default function PricingBaruView({ viewer = {} }) {
    // viewer = { loggedIn, tier, plan, licenseStatus, allowedModules } dari App.jsx (app-domain sahaja).
    // Render public/sesaat.ai tak dapat viewer → PricingSection fallback anon (selamat).
    // ⛔ Laluan bayaran hidup dalam useLangganan — SATU takrifan dikongsi dengan
    //    halaman jualan. Jangan salin semula ke sini.
    const { payLoading, langgan: handleSubscribe, goLogin } = useLangganan();
    return (
        <div className="min-h-screen bg-[#f4f3ef] text-[#14130f]" style={{ fontFamily: "'Inter', sans-serif" }}>

            {/* Instrument Serif (aksen italik hero) — Inter dah di-load global (index.html) */}
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&display=swap');`}</style>

            {/* ════════ NAV — komponen dikongsi /sesaat-1 (auto-sync) ════════ */}
            <SalesNav onLogin={goLogin} onPricing={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />

            {/* ════════ KANDUNGAN ════════ */}
            <div className="max-w-[1160px] mx-auto px-7 pt-14 pb-12">

                {/* Hero — saiz ikut salespage (Inter bold + Instrument Serif italik) */}
                <div className="max-w-3xl mb-12">
                    <h2 style={{ fontWeight: 700, fontSize: 'clamp(38px, 5.6vw, 62px)', lineHeight: 1.03, letterSpacing: '-0.03em' }}>
                        Pakej berbaloi untuk <span style={{ fontFamily: "'Instrument Serif', serif", fontStyle: 'italic', fontWeight: 400 }}>ejen affiliate</span>
                    </h2>
                    <p className="mt-4 text-[17px] leading-relaxed text-[#6b6a64]">
                        Pilih pelan yang sesuai. Naik taraf bila-bila masa.
                    </p>
                </div>

                {/* ─── PERBANDINGAN — komponen dikongsi (auto-sync /sesaat-1 + StartGate) ─── */}
                <PricingSection onSubscribe={handleSubscribe} payLoading={payLoading} fadeColor="#f4f3ef" viewer={viewer} />
            </div>

            {/* ════════ FAQ ════════ */}
            {/* FAQ — komponen dikongsi (auto-sync /sesaat-1 + StartGate) */}
            <FaqSection />

            {/* ════════ FOOTER ════════ */}
            <footer className="border-t border-[#e6e3db]">
                <div className="max-w-[1160px] mx-auto px-7 py-10">
                    <div className="flex items-center justify-between gap-4 flex-wrap pb-8 border-b border-[#e6e3db]">
                        <span className="text-base font-extrabold tracking-tight text-[#14130f]">SESAAT</span>
                        <div className="flex items-center gap-2">
                            <button onClick={goLogin} className="h-9 px-4 rounded-xl text-sm font-bold text-[#14130f] border border-[#e6e3db] bg-white hover:bg-[#faf9f5] transition-colors">Log masuk</button>
                            <button onClick={goLogin} className="h-9 px-4 rounded-xl text-sm font-bold text-[#14130f] bg-[#bef264] hover:bg-[#d9f99d] transition-colors">Daftar akaun</button>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 py-8">
                        {FOOTER_COLS.map((col) => (
                            <div key={col.title}>
                                <p className="text-[11px] font-bold uppercase tracking-wider text-[#9c9a92] mb-3">{col.title}</p>
                                <ul className="space-y-2">
                                    {col.links.map((l) => (
                                        <li key={l}>
                                            <span className="text-sm text-[#6b6a64] hover:text-[#14130f] cursor-pointer transition-colors">{l}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    <div className="pt-6 border-t border-[#e6e3db]">
                        <p className="text-xs text-[#9c9a92]">© 2026 SESAAT. Hak cipta terpelihara.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}
